import { push } from 'connected-react-router';

export const openMerch = (productId: string, section?: string) => {
  let path = `/merch/edit/${productId}/color-size`;

  if (section) {
    path = `/merch/edit/${productId}/${section}`;
  }

  return push(path);
};
